/**
 * Curated solid-icon set for IconPicker — GENERATED by `rushx icons:generate:picker`
 * from `svg-icons-picker/` (the Figma "Icons" frame, the source of truth). Keys
 * are stable kebab-case identifiers (the public `IconName` contract) and define
 * the grid order; `bookmark` is first as the design default. Keyword arrays are
 * search aliases matched (by substring) alongside the icon name.
 *
 * Do not edit by hand: re-export the SVGs from Figma or change the `CURATED`
 * alias map in `scripts/generate-icon-picker-glyphs.mjs` and rerun the script.
 */
const ICON_META = {
  bookmark: ['save', 'flag', 'favorite', 'saved'],
  home: ['house', 'dashboard', 'start'],
  bag: ['shopping', 'buy', 'store'],
  'chart-pie': ['analytics', 'stats', 'graph', 'data'],
  'chart-pie-alt': [],
  box: ['package', 'container', 'storage'],
  card: ['payment', 'credit', 'money'],
  wallet: ['money', 'cash', 'payment'],
  bank: ['money', 'finance', 'building'],
  sun: ['light', 'day', 'weather'],
  moon: ['night', 'dark', 'sleep'],
  palette: ['color', 'paint', 'art', 'design'],
  flask: ['science', 'lab', 'experiment'],
  'flask-alt': [],
  'shopping-basket': [],
  'shopping-bag': ['buy', 'store'],
  umbrella: ['weather', 'rain', 'protect'],
  calendar: ['date', 'schedule', 'event'],
  filter: ['sort', 'refine', 'funnel'],
  medkit: ['health', 'medical', 'aid'],
  clock: ['time', 'schedule', 'pending'],
  alarm: ['clock', 'reminder', 'wake'],
  timer: ['stopwatch', 'countdown', 'time'],
  lock: ['secure', 'private', 'locked'],
  unlock: ['open', 'access', 'unlocked'],
  'lock-time': [],
  eye: ['view', 'visible', 'show', 'preview'],
  'eye-closed': ['hidden', 'invisible', 'hide'],
  lightning: ['energy', 'fast', 'power', 'bolt'],
  'lightning-alt': [],
  shield: ['security', 'protect', 'safe'],
  'info-rect': ['information', 'details', 'note'],
  'info-circle': ['information', 'details', 'note', 'help'],
  'info-triangle': ['alert', 'caution', 'warning', 'danger'],
  'checked-box': ['done', 'complete', 'task', 'todo', 'tick'],
  notification: ['bell', 'alert', 'reminder'],
  'notification-on': ['bell', 'alert', 'reminder', 'active'],
  heart: ['love', 'like', 'favorite'],
  'heart-plus': ['favorite', 'add', 'like', 'save'],
  heartbeat: [],
  fire: ['hot', 'trending', 'flame'],
  'power-button': [],
  'lightbulb-alt': [],
  lightbulb: ['idea', 'tip', 'insight'],
  award: ['badge', 'achievement', 'medal', 'trophy'],
  'sand-watch': [],
  present: ['gift', 'reward', 'box'],
  'toggle-on': [],
  'toggle-off': [],
  university: ['school', 'education', 'learn'],
  'book-open': ['read', 'library', 'learn'],
  envelope: ['email', 'mail', 'message'],
  'envelope-open': ['email', 'mail', 'read'],
  contacts: [],
  user: ['person', 'profile', 'account', 'avatar'],
  'user-clock': [],
  'user-plus': [],
  'user-block': [],
  like: ['thumbs-up', 'approve'],
  dislike: ['thumbs-down', 'reject'],
  chat: ['message', 'comment', 'talk'],
  comment: ['chat', 'message', 'talk'],
  'comment-plus': [],
  'comment-minus': [],
  'comment-block': [],
  phone: ['call', 'contact', 'telephone'],
  'phone-miss': [],
  'phone-in': [],
  'phone-out': [],
  send: ['submit', 'deliver', 'share'],
  share: ['distribute', 'forward', 'publish'],
  forward: [],
  reply: [],
  'share-box': [],
  megaphone: ['announce', 'promote', 'broadcast', 'marketing', 'shout'],
  headphone: [],
  play: ['start', 'run', 'media'],
  pause: [],
  'fast-forward': [],
  'fast-rewind': [],
  'skip-next': [],
  'skip-prev': [],
  microphone: ['mic', 'audio', 'record'],
  'volume-up': [],
  'volume-down': [],
  'volume-off': [],
  file: ['document', 'page', 'text'],
  document: ['file', 'page', 'text'],
  picture: ['image', 'photo', 'gallery'],
  'file-user': [],
  'file-upload': ['import', 'attach'],
  'file-download': ['save', 'export'],
  invoice: ['bill', 'receipt', 'payment'],
  clipboard: [],
  'clipboard-alt': [],
  image: ['picture', 'photo', 'gallery'],
  folder: ['directory', 'group', 'storage'],
  'folder-open': [],
  'folder-lock': [],
  'folder-plus': [],
  'folder-delete': [],
  'folder-user': [],
  'folder-block': [],
  book: ['read', 'library', 'learn'],
  'book-check': [],
  'book-mark': [],
  cloud: ['storage', 'sync', 'weather'],
  login: [],
  logout: [],
  save: ['disk', 'store', 'floppy'],
  edit: ['pencil', 'write', 'modify'],
  'edit-alt': [],
  layout: [],
  rows: [],
  columns: [],
  apps: [],
  'settings-alt': [],
  star: ['favorite', 'rating', 'highlight'],
  settings: ['preferences', 'config', 'gear', 'options'],
  'zoom-in': [],
  'zoom-out': [],
  cursor: [],
  backspace: [],
  'heart-alt': ['love', 'like', 'favorite'],
  printer: [],
  desktop: ['screen', 'monitor', 'display', 'computer'],
  'mobile-phone': ['device', 'smartphone'],
  watch: [],
  gamepad: [],
  server: [],
  processor: [],
  'mouse-alt': [],
  mouse: [],
  binocular: [],
  'battery-full': [],
  camera: ['photo', 'capture', 'lens'],
  video: ['movie', 'clip', 'film'],
  dialpad: [],
  laptop: ['computer', 'device', 'work'],
  location: ['place', 'marker', 'map', 'geo'],
  'location-check': [],
  'location-plus': [],
  'location-question': [],
  explore: [],
  'current-location': [],
  navigation: [],
  globe: ['world', 'web', 'internet'],
  'map-location': [],
  'shopping-cart': ['buy', 'store', 'purchase'],
  experiment: ['science', 'lab', 'research', 'test'],
  music: ['audio', 'song', 'sound', 'note'],
  pin: ['location', 'place', 'marker', 'map'],
  tree: ['nature', 'forest', 'outdoor', 'plant'],
  flower: ['nature', 'bloom', 'garden', 'plant'],
  'frame-puzzle': ['piece', 'game', 'solve', 'jigsaw'],
  ghost: ['spooky', 'boo', 'spirit', 'halloween'],
  art: ['paint', 'draw', 'creative', 'design'],
  cat: ['animal', 'pet', 'kitten'],
  basket: ['shopping', 'buy', 'store'],
  diamond: ['gem', 'jewel', 'premium', 'valuable'],
  analytics: ['chart', 'stats', 'graph', 'data'],
  key: ['access', 'password', 'unlock'],
  suitcase: ['travel', 'luggage', 'bag', 'trip'],
  strong: ['muscle', 'power', 'fitness', 'gym'],
  'user-inside': ['person', 'profile', 'member', 'group'],
  't-shirt': ['clothes', 'apparel', 'merch'],
  skull: ['danger', 'death', 'poison'],
} satisfies Record<string, readonly string[]>

/** Stable identifier for a curated picker icon. */
export type IconName = keyof typeof ICON_META

/**
 * Narrows an arbitrary string to a curated {@link IconName}. Uses an own-property
 * check so inherited members like `toString` are rejected. Handy at boundaries
 * such as a persisted value that may name an icon no longer in the set.
 */
export function isIconName(value: string): value is IconName {
  return Object.hasOwn(ICON_META, value)
}

export { ICON_META }
